import { Grid } from "@mui/material";
import React from "react";

import LoadingOverlay from "src/containers/LoadingOverlay/LoadingOverlay";
import { EmployeeRef } from "src/models/employees";
import { TnADayDataDTO } from "src/models/tna/tna-data/tna-day-data-dto";
import { TnADayDataWithBreaksRef } from "src/models/tna/tna-day-data-with-breaks";
import MultipleEmployeesMassAnomaliesListTable from "./MultipleEmployeesMassAnomaliesListTable";
import useWindowSize from "../../../custom-hooks/useWindowSize/useWindowSize";

interface Props {
  item?: TnADayDataWithBreaksRef | TnADayDataDTO;
  handleNotifyParent: () => void;
  children?: React.ReactNode;
  buttonText?: string;
  buttonVariant?: "text" | "outlined" | "contained";
  customButtonStyle?: React.CSSProperties;
  buttonTitle?: string;
  disabled?: boolean;
  handleParentClose?: () => void;
  employee?: EmployeeRef | null;
}

export interface State {
  lastNotifiedOn: string;
  lastSignOffOn: string;
  loading: boolean;
  error: string;
  isOpen: boolean;
  isHistoryView: boolean;
}

const SendMassAnomaliesNotificationsWrapper = ({
  item,
  handleNotifyParent,
  children,
  buttonText,
  buttonVariant,
  customButtonStyle,
  buttonTitle,
  disabled = false,
  handleParentClose,
  employee,
}: Props) => {
  const { height } = useWindowSize();

  return (
    <LoadingOverlay loading={height === 0}>
      <Grid>
        {height !== 0 && (
          <MultipleEmployeesMassAnomaliesListTable
            handleNotifyParent={handleNotifyParent}
            tableHeight={height - height / 2.5}
            handleClose={handleParentClose}
            employee={employee ?? null}
          />
        )}
      </Grid>
    </LoadingOverlay>
  );
};

export default React.memo(SendMassAnomaliesNotificationsWrapper);
